<template>
  <van-overlay :show="show" >
    <div class="bg" @click.stop>
      <div class="box">
        <div class="box-box">
          <div class="title-box size-18">
            <!-- <div v-if="type === 'sign'">
              <div class="margin-top">连续签到</div>
              <div class="margin-15"><span style="font-size:30px;color:#F6BF4C;">3</span>天</div>
            </div>
            <div v-if="type === 'order'">
              <div class="margin-top2">已下一笔订单</div>
            </div>
            <div v-if="type === 'watch'">
              <div class="margin-top2">已浏览易加商城15s</div>
            </div>
            <div v-if="type === 'scan'">
              <div class="margin-top2">已扫码10次</div>
            </div>
            <div v-if="type === 'exchange'">
              <div class="margin-top2">已兑换易加2023授权牌</div>
            </div> -->
            <div v-if="activityPrize.couponDTO">
              <div class="margin-bottom" style="font-weight: bold;">恭喜您获得
              </div>
              <div class="margin-bottom" style="color:#333333;font-weight: bold;">一张礼品券</div>
              <div class="size-14 margin-bottom">请在“我的卡包”中查看</div>
            </div>
            <div v-else>
              <div class="margin-bottom" style="font-weight: bold;">恭喜您获得
              </div>
              <div class="margin-bottom" style="color:#333333;font-weight: bold;">一张积分券</div>
              <div class="size-14 margin-bottom">已自动兑换，请尽快使用~</div>
            </div>

            <!-- <div class="margin-bottom" v-else>
              <div v-if="activityPrize.couponDTO && activityPrize.couponDTO.couponType === '02'">
                <div class="margin-bottom"> 恭喜您获得 <span style="color:#F6BF4C;">1</span>张满减券！</div>
                <div class="size-14 margin-bottom">有效期半年，请尽快使用~</div>
              </div>
              <div v-if="activityPrize.couponDTO && activityPrize.couponDTO.couponType === '03'">
                <div class="margin-bottom">恭喜您获得<span style="color:#F6BF4C;">1</span>张卡券</div>
                <div class="size-14 margin-bottom">有效期半年，请尽快使用~</div>
              </div>
            </div> -->
          </div>
          <div class="coupon-box">
            <div class="coupon">
              <div v-if="activityPrize.couponDTO " class="flex-between">
                <div class="left">
                  <div class="color-white">
                    <div>礼品券</div>
                  </div>
                </div>
                <div class="right">
                  <div class="margin-y-15">
                    <div style="font-size:14px;color: #333333;font-weight: bold;">{{ activityPrize.itemName }}</div>
                    <div style="margin-top:24px; ">
                      有效期：6个月
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="flex-between">
                <div class="left">
                  <div class="color-white">
                    <div>积分券</div>
                  </div>
                </div>
                <div class="right">
                  <div class="margin-y-15">
                    <div style="font-size:14px;color: #333333;font-weight: bold;">{{ activityPrize.coinQty }}积分</div>
                    <div style="margin-top:24px; ">
                      有效期：6个月
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div v-else class="flex-between">
                <div class="left">
                  <div class="color-white">
                    <div style="font-size:20px"
                      v-if="activityPrize.couponDTO && activityPrize.couponDTO.couponType === '02'">
                      满减券
                    </div>
                    <div style="font-size:20px"
                      v-if="activityPrize.couponDTO && activityPrize.couponDTO.couponType === '03'">
                      课程券
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="margin-y-15"
                    v-if="activityPrize.couponDTO && activityPrize.couponDTO.couponType === '02'">
                    满{{ activityPrize.couponDTO.deductPointLimit }}易加积分减{{
                      activityPrize.couponDTO.deductPointValue
                    }}积分
                  </div>
                  <div class="margin-y-10 coupon-name"
                    v-if="activityPrize.couponDTO && activityPrize.couponDTO.couponType === '03'">
                    {{ activityPrize.couponDTO.couponName }}
                  </div>
                  <div>
                    {{ activityPrize.couponDTO.createDate | parseTime('{y}.{m}.{d}') }} - {{
                      activityPrize.couponDTO.expireDate |
                        parseTime('{y}.{m}.{d}')
                    }}
                  </div>
                </div>
              </div> -->
              <div class="use" @click="goToHome(activityPrize)">
                  <!-- <div class="margin-5"
                  v-if="!activityPrize.couponDTO || (activityPrize.couponDTO && activityPrize.couponDTO.couponType !== '03') || level === '03' ">
                  浏 览 <br />
                  商 城
                </div> -->
                <div class="use-btn" v-if="activityPrize.couponDTO">
                  立即使用
                </div>
                <div class="use-btn" v-else>
                  浏览商城
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="go-back" @click="goToActivity"></div> -->
          <div class="flex-btn">
            <div class="btn" style="color:#5696A0;margin-right: 10px;" @click="closePopup">我知道了</div>
            <div class="btn" v-if="activityPrize.couponDTO" style="background-color:#5696A0;color:#fff;margin-left: 10px;" @click="goUserCoupon">我的卡包</div>
          </div>
        </div>
        <!-- <img v-if="isShowClose" class="close" @click="closePopup" src="../assets/images/activity/cards/close.png"
          alt=""> -->
      </div>
    </div>
  </van-overlay>
</template>

<script>
import cartApi from '@/api/cart'

export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isShowClose: {
      type: Boolean,
      default: true
    },
    activityPrize: {
      type: Object,
      default: () => { }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show_: true,
      isNext: false,
      level: ''
    }
  },
  watch: {
    show (val) {
      this.show_ = val || false
    }
  },
  computed: {

  },
  created () {
    this.level = JSON.parse(localStorage.getItem('userInfo')).clientInfo.clientUserDTO.userRole
    console.log(this.level, 'this.level')
  },
  methods: {
    closePopup () {
      console.log(this.activityPrize, 'activityPrize')
      this.show_ = false
      this.isNext = true
      this.$emit('update:show', this.show_)
      this.$emit('closePopup', this.isNext)
    },
    goToActivity () {
      this.show_ = false
      this.$emit('clickClose')
      this.$router.push({ name: 'activity-cards' })
    },
    goUserCoupon () {
      this.$router.push({ name: 'userCoupon' })
    },
    goToHome (activityPrize) {
      if (!activityPrize.couponDTO || (activityPrize.couponDTO && activityPrize.couponDTO.couponType !== '03')) {
        this.$emit('clickClose')
        this.$router.push({ name: 'home-main' })
        this.show_ = false
      } else {
        const payload = {
          itemQuantity: 1,
          itemId: activityPrize.couponDTO.limitItemId,
          couponId: activityPrize.couponDTO.couponId
        }
        cartApi.queryCartBuy(payload).then(res => {
          if (res.data.resultCode === '0') {
            this.$emit('clickClose')
            this.$router.push({
              name: 'direct_buy',
              query: {
                itemId: activityPrize.couponDTO.limitItemId,
                couponId: activityPrize.couponDTO.couponId
              }
            })
            this.show_ = false
          }
        })
      }
      this.$emit('update:show', this.show_)
    }
  }
}
</script>
<style lang='less' scoped>
.van-overlay {
  z-index: 10000;
}

.margin-5 {
  margin-bottom: 2px;
  margin-top: 2px;
}

.flex-between {
  display: flex;
  justify-content: flex-start;
}

.color-red {
  color: #FF3527;
  margin-top: 30px;
  margin-bottom: 10px;
}
.color-white{
  color: #fff;
  // margin-top: 34px;
  line-height: 90px;
  font-size: 18px;
}

.margin-y-15 {
  margin-top: 20px;
  margin-bottom: 10px;
}

.margin-y-10 {
  margin-top: 20px;
  margin-bottom: 5px;
}

.size-18 {
  font-size: 18px;
  font-weight: 500;
}

.margin-top {
  margin-top: 175px;
}

.margin-top2 {
  margin-top: 190px;
  margin-bottom: 20px;
}

.margin-15 {
  margin-top: 15px;
  margin-bottom: 15px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.size-14 {
  font-size: 14px;
  font-weight: 500;
}

.close {
  width: 40px;
  margin-left: 140px;
  margin-top: 80px;
  z-index: 9;
}

.bg {
  color: #333333;
  width: 330px;
  height: 400px;
  margin: auto;
  margin-top: 50px;

  .box {
    background-image: url(../assets/images/activity/cards/pop-up.png);
    // background-image: url(../assets/images/activity/cards/pop-ups.png);
    background-size: 100%;
    background-repeat: no-repeat;

    .box-box {
      width: 100%;
      height: 458px;
      margin: auto;
      display: inline-block;
    .flex-btn{
      display: flex;
      justify-content: center;
      .btn{
        cursor: pointer;
        padding: 8px 28px;
        font-size: 16px;
        border: 1px solid #5696A0 ;
        border-radius: 30px;
      }
    }
      .title-box {
        font-weight: 500;
        text-align: center;
        margin-top: 170px;
      }

      .coupon-box {
        height: 90px;
        width: 300px;
        margin: 20px auto;

        .coupon {
          height: 89px;
          background-image: url(../assets/images/activity/cards/coupons.png);
          // background-image: url(../assets/images/activity/cards/coupon.png);
          background-size: 100%;
          background-repeat: no-repeat;
          position: relative;
          font-size: 10px;
          text-align: center;

          .left {
            width: 90px;
            font-size: 10px;
            height: 90px;
            text-align: center;

            .coupon-name {
              white-space: nowrap;
              text-overflow: ellipsis;
              width: 170px;
              height: 15px;
              overflow: hidden;
            }
          }

          .right {
            width: 115px;
            height: 90px;
            text-align: left;
            margin-left: 5px;
          }

          .use {
            font-size: 12px;
            color: #ffffff;
            position: absolute;
            background-color: #5696A0;
            right: 10px;
            bottom: 15px;
            border-radius: 5px;
            .use-btn{
            padding: 5px 10px;
            }
          }
        }
      }

      .go-back {
        background-image: url(../assets/images/activity/cards/back-activity.png);
        background-size: 100%;
        background-repeat: no-repeat;
        width: 270px;
        height: 40px;
        margin-left: 30px;
      }
    }

  }

}
</style>
